export default __webpack_public_path__ + "static/media/subtract.f8189226.svg";